import React, { useEffect } from 'react';
import { Button, Typography } from '@one-thd/sui-atomic-components';

const ListBenefitsCallToAction = () => {

  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('list-benefits-call-to-action.ready'); }, []);

  return (
    <div className="sui-flex-col sui-pt-4 sui-pb-4" data-component="ListBenefitsCallToAction">
      <div className="sui-flex sui-justify-center sui-text-center sui-mb-3">
        <Typography
          color="primary"
          weight="bold"
          variant="h1"
        >
          Great Projects Start With a List
        </Typography>
      </div>
      <div className="sui-flex sui-justify-center sui-text-center">
        <Typography
          variant="body-lg"
        >
          Sign in to plan a DIY project, dream up a wish list, or create a gift list
        </Typography>
      </div>
      <div className="sui-flex sui-justify-center sui-mt-7 sui-mb-7">
        <Button
          variant="primary"
          disabled={false}
          fullWidth={false}
          tag="a"
          href="/auth/view/signin?redirect=/list/view/summary"
        >
          Sign In or Create an Account
        </Button>
      </div>
    </div>
  );
};

ListBenefitsCallToAction.displayName = 'ListBenefitsCallToAction';

export { ListBenefitsCallToAction };
